import { defineStore } from 'pinia';

export const flightdata = defineStore('flightdata', {
  state: () => ({
    token: null,
    isToaster: false,
    isSuccessToaster: false,
    isDangerToaster: false,
    toastrMsg: '',
    trainprocesdata: '',
    isHolidaySectionShow: true
  }),
  actions: {
    activateDangerToaster(val, type = 'd') {
      type == 'd' ? this.isDangerToaster = true : this.isSuccessToaster = true,
        this.toastrMsg = val;
      setTimeout(() => {
        this.isSuccessToaster = this.isDangerToaster = false;
        this.toastrMsg = '';
      }, 5000);
    },
    checkRouteAndSetState(route) {
      if (route.name === 'filghtDetails' || route.name === 'filghtBookingDetails'  || route.name === 'flightReport'|| route.name === 'flightBookingreport' || route.name === 'FlightTicketView'
        || route.name === 'cancelFlightBookingView' ) {
        this.isHolidaySectionShow = false
      }
      else
      {
        this.isHolidaySectionShow = true
      }
    }
  },

  persist: true,
});

